import { render, staticRenderFns } from "./airdrop-treasury.vue?vue&type=template&id=091a5dd2&scoped=true&"
import script from "./airdrop-treasury.vue?vue&type=script&lang=ts&"
export * from "./airdrop-treasury.vue?vue&type=script&lang=ts&"
import style0 from "./airdrop-treasury.vue?vue&type=style&index=0&id=091a5dd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091a5dd2",
  null
  
)

export default component.exports